import styled from 'styled-components'

export const StyledNavContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 6px;
    padding: 6px 8px 8px 8px;
    margin: 0 8px 8px 8px;
    background-color: ${({ theme }) => theme.colours.background.dark_blue};
    border-radius: 10px;
`

export const StyledNavTab = styled.div<{ $showPill?: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 8px 10px;
    border-radius: 10px;
    cursor: pointer;
    text-decoration: none;
    transition: background-color 0.2s ease;
    background-color: ${({ theme, $showPill }) =>
        $showPill ? theme.colours.background.blue : 'transparent'};
    flex: 1;
`

export const StyledNavIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
`

export const StyledNavLabel = styled.span<{ $show?: boolean }>`
    color: ${({ theme }) => theme.colours.font.green};
    font-size: 10px;
    white-space: nowrap;
    overflow: hidden;
    max-width: ${({ $show }) => ($show ? '60px' : '0')};
    opacity: ${({ $show }) => ($show ? '1' : '0')};
    margin-left: ${({ $show }) => ($show ? '6px' : '0')};
    transition: max-width 0.2s ease, opacity 0.2s ease, margin-left 0.2s ease;
`

export const StyledBrokerContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`

export const StyledBrokerDropDown = styled.div`
    position: absolute;
    background-color: ${({ theme }) => theme.colours.background.primary};
    border-radius: 6px;
    margin-top: 4px;
    right: 0;
    z-index: 1000;
    cursor: auto;
    padding: 12px;
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colours.background.grey};
`

export const StyledBrokerMenuItem = styled.div`
    color: ${({ theme }) => theme.colours.font.blue};
    font-size: 12px;
    white-space: nowrap;
    text-align: left;
    cursor: pointer;
`

export const StyledBrokerMenuItemLink = styled.a`
    color: ${({ theme }) => theme.colours.font.blue};
    font-size: 12px;
    white-space: nowrap;
    text-align: left;
    cursor: pointer;
    text-decoration: none;
`

export const StyledBrokerDivider = styled.hr`
    border: none;
    border-top: 1px solid ${({ theme }) => theme.colours.font.light_grey};
    margin: 8px 0;
`
